'use client'

import { ComponentProps } from 'react'

import { LinkifiedMessage } from '@marketplace-web/linkified-message/linkified-message-feature'

type Props = {
  conversationId?: string
} & ComponentProps<typeof LinkifiedMessage>

const MessageText = ({ conversationId, ...props }: Props) => {
  return (
    <LinkifiedMessage
      {...props}
      trackingData={{
        ...(conversationId && { thread_id: conversationId }),
      }}
    />
  )
}

export default MessageText
